import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Axios from "../../axios/axios";
import { Header } from "../../components/SpearParts/Layouts/Header";
import { Footer } from "../../components/SpearParts/Layouts/Footer";
import { toTitleCase } from "../../components/utils/StringUtil";
import TopNavBar from "../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../components/SpearParts/Layouts/TopSearchBar";

function ViewCart() {
  const { id } = useParams();
  const [userInfo, setUserInfo] = useState(null);
  const [cart, setCart] = useState([]);
  const [notes, setNotes] = useState("");
  const [businessType, setBusinessType] = useState("");

  useEffect(() => {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    setUserInfo(userInfo?.customerId);

    const storedBusinessType = sessionStorage.getItem("businessType") || "";
    setBusinessType(storedBusinessType.toLowerCase()); // normalize to lowercase
  }, []);

  useEffect(() => {
    if (userInfo) {
      cartData();
    }
  }, [userInfo]);

  const saveCartNotes = async () => {
    if (!cart?._id) {
      console.error("Cart ID is missing!");
      return;
    }

    try {
      const res = await Axios.patch(`/cart/update/${cart._id}`, {
        ...cart,
        suggestion: notes,
      });
      console.log("Notes saved successfully:", res.data);
      // Optionally show a success message
    } catch (error) {
      console.error(
        "Error saving notes:",
        error.response?.data?.message || error.message
      );
    }
  };

  const cartData = async () => {
    try {
      console.log("Fetching cart for user:", userInfo);
      const res = await Axios.get(`/cart/${userInfo}`);
      console.log("API Response:", res.data);

      // Retrieve businessType from session storage
      const businessType = (
        sessionStorage.getItem("businessType") || ""
      ).toLowerCase();

      const filteredCart = {
        ...res.data,
        items:
          res.data?.items?.filter((item) =>
            item.productType.some((pt) => pt.toLowerCase() === businessType)
          ) || [],
      };
      // Recalculate totalAmount based on filtered items
      filteredCart.totalAmount = filteredCart.items.reduce(
        (sum, item) => sum + item.totalItemPrice,
        0
      );

      // Update the cart state with filtered items
      setCart(filteredCart);
    } catch (error) {
      console.error("Error fetching cart:", error);
    }
  };

  const cartId = cart?._id; // Ensure cart exists
  console.log("Cart ID:", cartId);

  const itemId = cart?.items?.length > 0 ? cart.items[0]._id : null; // Check if items exist
  console.log("Item ID:", itemId);

  const removeCartItem = async (cartId, itemId) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to remove this item?"
    );
    if (!isConfirmed) return;

    if (!cartId || !itemId) {
      console.error("Cart ID or Item ID is missing!");
      return;
    }

    try {
      const res = await Axios.delete(`/cart/${cartId}/item/${itemId}`);
      console.log(res.data.message);

      // Update state after successful removal
      setCart((prevCart) => ({
        ...prevCart,
        items: prevCart?.items?.filter((item) => item._id !== itemId) || [],
        totalAmount:
          prevCart?.items
            ?.filter((item) => item._id !== itemId)
            .reduce((acc, item) => acc + (item.totalItemPrice || 0), 0) || 0,
      }));
    } catch (error) {
      console.error(
        "Error removing item:",
        error.response?.data?.message || error.message
      );
    }
  };

  const clearCart = async () => {
    const isConfirmed = window.confirm("Are you sure you want to clear?");
    if (!isConfirmed) return;

    if (!cart?._id) {
      console.error("Cart ID is missing!");
      return;
    }

    try {
      console.log(`Clearing cart with ID: ${cart._id}`);
      const res = await Axios.delete(`/cart/${cart._id}`);
      console.log(res.data.message);

      // Update state: Reset cart
      setCart({
        items: [],
        totalAmount: 0,
        tax: 0,
        netAmount: 0,
      });
    } catch (error) {
      console.error(
        "Error clearing cart:",
        error.response?.data?.message || error.message
      );
    }
  };

  const updateCartItemQuantity = async (cartId, itemId, newQuantity) => {
    if (newQuantity < 1) return; // Prevent negative or zero quantity

    try {
      // Create a copy of the current cart state
      const updatedCart = { ...cart };

      // Find the item in the cart and update its quantity & total price
      updatedCart.items = updatedCart.items.map((item) => {
        if (item._id === itemId) {
          return {
            ...item,
            quantity: newQuantity,
            totalItemPrice: item.unitPrice * newQuantity, // Calculate new total price
          };
        }
        return item;
      });

      // Recalculate totalAmount
      updatedCart.totalAmount = updatedCart.items.reduce(
        (acc, item) => acc + (item.totalItemPrice || 0),
        0
      );

      // Send the updated cart to the backend
      await Axios.patch(`/cart/update/${cartId}`, updatedCart);

      console.log("Cart updated successfully");

      // Fetch the latest cart from the backend after updating
      cartData(); // This will refresh the cart with updated data
    } catch (error) {
      console.error(
        "Error updating quantity:",
        error.response?.data?.message || error.message
      );
    }
  };

  const style = {
    fontFamily: "'Poppins', sans-serif",
    position: "relative",
    fontWeight: 700,
    color: "#353C4B",
  };
  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: "url(/images/bnr-bg.png)",
  };
  return (
    <div className="New-Dashboard" style={sectionStyle}>
      {/* <Header /> */}
      <section >
        <div className="Main-div">
          <TopNavBar />
          <div className="TopSearchBar">
            <TopSearchBar />
          </div>
          <div class="container" style={{ marginTop: "20px" }}>
            <div class="mt-5 result-select">
              <div className="col-lg-12">
                <div class="shoppingCart">
                  <h6 class="mb-4" style={style}>
                    Shopping Cart
                  </h6>
                  {/* <div class="a-together">
                    <a href="#" class="quote">
                      Request a quote{" "}
                    </a>
                    <a href="#">
                      Export <img src="/images/excel.svg" />{" "}
                    </a>
                  </div> */}
                </div>

                <div class="table-responsive">
                  <table className="table search-table productpriceDatailsTable">
                    <tbody>
                      {/* Table Head */}
                      <tr>
                        <td colSpan="8" className="border-td p-0">
                          <table className="table search-inner-table head-table">
                            <tbody>
                              <tr className="productPriceHeading">
                                <th
                                  className="align-middle theadDataThree"
                                  width="80"
                                  style={{ backgroundColor: "#353c4b" }}
                                >
                                  Brand
                                </th>
                                <th
                                  className="align-middle theadDataThree"
                                  width="80"
                                  style={{ backgroundColor: "#353c4b" }}
                                >
                                  Part Number
                                </th>
                                <th
                                  className="align-middle theadDataThree"
                                  width="80"
                                  style={{ backgroundColor: "#353c4b" }}
                                >
                                  Product Name
                                </th>

                                {/* <th className="align-middle theadDataFour" width="100" style={{ backgroundColor: "##353c4b" }}>Unit Price</th>
                              <th className="align-middle theadDataFive" width="100" style={{ backgroundColor: "##353c4b" }}>Total Price</th> */}
                                <th
                                  className="align-middle theadDataTen"
                                  width="70"
                                  style={{ backgroundColor: "#353c4b" }}
                                >
                                  Quantity
                                </th>
                                <th
                                  className="align-middle theadDataSeven"
                                  width="60"
                                  style={{ backgroundColor: "#353c4b" }}
                                ></th>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>

                      {/* Table Body */}
                      <tr>
                        <td colSpan="8" className="border-td p-0">
                          <table className="table search-inner-table">
                            <tbody>
                              {cart && cart.items?.length > 0 ? (
                                cart.items.map((item, index) => (
                                  <tr key={index}>
                                    <td
                                      className="align-middle data_three"
                                      width="80"
                                      style={{
                                        color: "#20689d",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {item.brand?.name}
                                    </td>
                                    <td
                                      className="align-middle data_three"
                                      width="80"
                                      style={{
                                        color: "#20689d",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {item.partNo}
                                    </td>
                                    <td
                                      className="align-middle data_three"
                                      width="80"
                                      style={{
                                        color: "#20689d",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {toTitleCase(item.productName)}

                                      {/* Show rental details only if businessType is rental */}
                                      {businessType === "rental" && (
                                        <div
                                          style={{
                                            fontSize: "12px",
                                            color: "#555",
                                            marginTop: "4px",
                                          }}
                                        >
                                          <div>
                                            <strong>Start:</strong>{" "}
                                            {item.rentStartDate
                                              ? new Date(
                                                  item.rentStartDate
                                                ).toLocaleDateString()
                                              : "-"}
                                          </div>
                                          <div>
                                            <strong>End:</strong>{" "}
                                            {item.rentEndDate
                                              ? new Date(
                                                  item.rentEndDate
                                                ).toLocaleDateString()
                                              : "-"}
                                          </div>
                                          <div>
                                            <strong>Days:</strong>{" "}
                                            {item.rentalDays || "-"}
                                          </div>
                                        </div>
                                      )}
                                    </td>
                                    {/* <td className="align-middle data_four" width="100">{item.unitPrice}</td>
                                  <td className="align-middle data_five" width="100">{item.totalItemPrice}</td> */}
                                    <td
                                      className="align-middle data_ten addCartBlueClr"
                                      width="70"
                                    >
                                      <input
                                        className="form-control cartNumber"
                                        min={1}
                                        type="number"
                                        name="count"
                                        id={`count${index}`}
                                        value={item.quantity}
                                        onChange={(e) =>
                                          updateCartItemQuantity(
                                            cart._id,
                                            item._id,
                                            parseInt(e.target.value)
                                          )
                                        }
                                      />
                                    </td>
                                    <td
                                      className="align-middle data_seven"
                                      width="60"
                                      onClick={() =>
                                        removeCartItem(cart?._id, item?._id)
                                      }
                                    >
                                      <img
                                        src="/images/close.svg"
                                        alt="Remove"
                                      />
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="7" className="text-center">
                                    No items in cart
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="row ">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-7">
                        <a
                          href="/whole-products"
                          class="btn addItemsBtn"
                          style={{ backgroundColor: "#20689d" }}
                        >
                          {" "}
                          Add more items <img src="/images/plus-icon.svg" />{" "}
                        </a>
                      </div>
                      <div className="col-md-5 col-12">
                        <a
                          href="#"
                          className="btn clearCartBtn w-100"
                          onClick={clearCart}
                        >
                          Clear cart
                        </a>
                      </div>

                      <div class="row mt-3">
                        <div class="col-md-12">
                          <label
                            htmlFor="cartNotes"
                            style={{ fontWeight: "bold", marginBottom: "5px" }}
                          >
                            {" "}
                            Request For Additional Products:
                          </label>
                          <textarea
                            id="cartNotes"
                            class="form-control"
                            rows="3"
                            placeholder="Enter any special instructions or notes..."
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                            style={{
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              padding: "8px",
                              width: "100%",
                              marginBottom: "10px",
                            }}
                          />
                          <button
                            onClick={saveCartNotes}
                            style={{
                              backgroundColor: "#20689d",
                              color: "white",
                              border: "none",
                              padding: "8px 15px",
                              borderRadius: "4px",
                              cursor: "pointer",
                            }}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4"></div>
                  <div class="col-md-4">
                    <div class="cartTotal">
                      <div class="orderTotal">
                        <div style={{ display: "flex" }}>
                          <h6>{cart?.items?.length || 0} items Added</h6>
                          <span class="alreadyUsed">- </span>
                        </div>
                        {/* <div style={{ display: "flex" }}>
                        <h6>Shipping: </h6>
                        <span class="alreadyUsed"> - </span>
                      </div> */}
                        {/* <div style={{ display: "flex" }}>
                        <div class="alreadyUsed orderTotalCost">
                          <p> Total: </p>
                          <h3 class="totalRedClr">
                            AED 
                          </h3>
                        </div>
                      </div> */}
                        <div class="mt-3">
                          <Link
                            to="/delivery"
                            class="orderContinueBtn"
                            style={{ textDecoration: "none" }}
                          >
                            Place order
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Footer /> */}
    </div>
  );
}

export default ViewCart;
